export default __webpack_public_path__ + "static/media/Blade's Bracers of Shattered Souls.02630f83.jpg";